import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import { SignupsAppState } from "Signups/state.js";

const NewSignupCreationFlowContext = createContext();

/* this is used to assist the frontend in prompting users to continue to add new items */

export function NewSignupCreationFlowProvider({ children }) {
  const [{ currentSignupList }] = useContext(SignupsAppState);

  const signupItems = currentSignupList?.signupItems;
  const signupListID = currentSignupList?.ID;

  const [lastCreatedSignupItemID, setLastCreatedSignupItemID] = useState(false);

  const forceToAddItem =
    signupItems &&
    (signupItems.length === 0 ||
      (signupItems.length === 1 &&
        signupItems[0].name === "New Item" &&
        lastCreatedSignupItemID === parseInt(signupItems[0].ID)));

  const [firstItemCreated, setFirstItemCreated] = useState(!forceToAddItem);

  const [creatingSignupID, setCreatingSignupID] = useState(forceToAddItem);

  const beginItemCreationFlow = (signupID) => setCreatingSignupID(signupID);

  const cancelCreationFlow = useCallback(() => {
    setCreatingSignupID(false);
    setFirstItemCreated(true);
    setLastCreatedSignupItemID(false);
  }, []);

  const hideItemsList = forceToAddItem || !firstItemCreated;

  useEffect(() => {
    setFirstItemCreated(!forceToAddItem);
    setCreatingSignupID(forceToAddItem);
  }, [signupListID]);

  const value = {
    beginItemCreationFlow,
    cancelCreationFlow,
    isInCreationFlow: Boolean(creatingSignupID),
    forceToAddItem,
    setFirstItemCreated,
    firstItemCreated,
    hideItemsList,
    lastCreatedSignupItemID,
    setLastCreatedSignupItemID,
  };

  return (
    <NewSignupCreationFlowContext.Provider value={value}>
      {children}
    </NewSignupCreationFlowContext.Provider>
  );
}

export const useNewSignupCreationFlow = () => {
  const context = useContext(NewSignupCreationFlowContext);
  if (!context) {
    throw new Error(
      "useNewSignupCreationFlow must be used within a NewSignupCreationFlowContext.Provider"
    );
  }

  return context;
};
